/**
 * Batch mode constants.
 *
 * Batch mode captures many webcam photos locally, then runs one recognition
 * pass over the whole queue and reviews the results one photo at a time.
 */

/** Largest number of photos a single batch pass may hold. */
export const BATCH_MODE_MAX_CAPTURES = 50;

/** Recognition requests allowed in flight at once during the identify pass. */
export const BATCH_IDENTIFY_CONCURRENCY = 3;

/** Item types the batch capture tray can hint to the recognition service. */
export const BATCH_MODE_ITEM_TYPES = ['PART', 'MINIFIG', 'SET'];

/** Every status a queued capture can hold. */
export const BATCH_CAPTURE_STATUSES = [
    'queued',
    'identifying',
    'identified',
    'nomatch',
    'error',
    'added',
    'skipped'
];

/** Statuses that still need a decision from the user. */
export const BATCH_UNRESOLVED_STATUSES = ['queued', 'identifying', 'identified', 'nomatch', 'error'];

/** Phases of a batch pass. */
export const BATCH_MODE_PHASES = ['capture', 'identifying', 'review', 'summary'];
